/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import { getResource } from '../../selectors/generic';
import Tooltip from './layout/Tooltip';

export const ProductCardIcon = ({ icon, label, plantForwardIcon = false }) => {
  return (
    <div className={`card-icon__holder ${plantForwardIcon ? 'plant-forward' : ''}`}>
      <Tooltip placement="left" trigger="hover" tooltip={label}>
        <img src={getResource(icon)} alt={label} className="card-icon__holder-image" />
      </Tooltip>
    </div>
  );
};
